module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Background</span></div>\r\n")
    ;  if (isPageForm === false){
    ; __append("\r\n    <div class=\"prop-header\"><span class=\"prop-label\">")
    ; __append(escapeFn(viewTitle))
    ; __append("</span></div>\r\n")
    ; }
    ; __append("\r\n<div class=\"row\"> \r\n    ")
    ;  if ((isReportForm === true && viewTitle !== '') || isGroupContainer ) { 
    ; __append("\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">Picture</label>  \r\n    ")
    ; }else if (viewTitle  === '' || isPageForm === true){
    ; __append(" \r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">Picture</label>  \r\n      \r\n    ")
    ; }else{
    ; __append("\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-60\">&nbsp;</label>  \r\n    ")
    ; }
    ; __append("\r\n            <div>\r\n                <select name=\"stylePictureSelect\"  id=\"stylePictureSelect\">\r\n                    <option value=\"None\">None</option>\r\n                </select>\r\n            </div>\r\n            \r\n    </div>\r\n\r\n    ")
    ; if ((isReportForm === true && viewTitle !== '') || isGroupContainer || isSectionControl){
    ; __append("\r\n        <div class=\"col-md-4 prop-sublabel nopadding-r\">\r\n            <input type=\"checkbox\" id=\"preloadImage\" name=\"preloadImage\"> \r\n                <span class=\"prop-sublabel\">Pre-load</span>\r\n        </div>\r\n    ")
    ; }
    ; __append("\r\n\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-8 subsection nopadding-r\">\r\n        ")
    ;  if ((isReportForm && viewTitle !== '') ||  (viewTitle  === '' || isPageForm) || isGroupContainer) { 
    ; __append("\r\n            <label class=\"prop-sublabel label-60\">Align</label>   \r\n        ")
    ; }else{
    ; __append("\r\n            <label class=\"prop-sublabel label-45\">Align</label>  \r\n        ")
    ; }
    ; __append("\r\n        <div>\r\n            <select name=\"backgroundImageStyle\"  id=\"backgroundImageStyle\">\r\n                <option value=\"center\">Center</option>\r\n                <option value=\"stretch\">Stretch</option>\r\n                <option value=\"tile\">Tile</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    \r\n</div>\r\n")
  }
  return __output;

}